import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { observer, inject } from 'mobx-react';

import ItemList from '../Form/ItemList';

@inject('tagStore')
@observer
class TagList extends Component {
  
  flattenTags(dataArray) {
    const data = dataArray || [];

    const arr = [];

    data.forEach(tag => {
      arr.push({
        type: 'TAG',
        level: 1,
        key: tag.id,
        slug: '/tag',

        id: tag.id,
        name: tag.name,
        description: tag.description,
      });

      if (tag.stations) {
        tag.stations.forEach(station => {
          arr.push({
            type: 'STATION',
            level: 2,
            key: `${tag.id}.${station.id}`,
            slug: null,
            parent_id: tag.id,

            id: station.id,
            name: <Link to={`/station/${station.id}`}>{station.name}</Link>,
            description: station.description,
          });
        });
      }
    });

    return arr;
  }

  render() {
    const { tagStore, children, params } = this.props;
    let data = tagStore.items && this.flattenTags(tagStore.items)
    
    return (
      <div>
        <ItemList
          hierTable={true}
          store = {tagStore}
          slug={'tag'}
          data={data}
          columns={[
            { key: 'id', label: 'ID', colClassName: 'hidden' },
            { key: 'name', label: 'Name', colClassName: 'level-2-indent-left' },
            { key: 'description', label: 'Description' },
          ]
          }
          children={children}
          allowAdd
          allowEdit
          allowDelete
          resources={{ parent: 'tag', child: 'station' }}
          actions={[{ label: 'Parameter', link: '/tag/{id}/parameter', level: 1 }]}
          params={params}
        />
      </div>
    );
  }
}

export default TagList;



// WEBPACK FOOTER //
// ./src/components/Tag/TagList.js